import {
  initialState,
  Actions,
  State,
  EDIT_PERIODIC_CHECK_FEEDBACK,
  EDIT_PERIODIC_CHECK_FEEDBACK_SUCCESS,
  EDIT_PERIODIC_CHECK_FEEDBACK_ERROR,
  RESET_EDIT_PERIODIC_CHECK_FEEDBACK,
} from '../../types/periodic-check/edit-feedback'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_PERIODIC_CHECK_FEEDBACK:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case EDIT_PERIODIC_CHECK_FEEDBACK_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case EDIT_PERIODIC_CHECK_FEEDBACK_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      }
    case RESET_EDIT_PERIODIC_CHECK_FEEDBACK:
      return initialState
    default:
      return state
  }
}

export default reducers
